// import Swiper JS
import Swiper from 'swiper';
import { Autoplay, Pagination, A11y } from 'swiper/modules';

document.addEventListener("DOMContentLoaded", () => {
    const uspSlider = new Swiper('.abo-swiper-usps', {
        modules: [Autoplay],
        slidesPerView: 1,
        loop: true,
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
        spaceBetween: 30,
        breakpoints: {
            768: {
                slidesPerView: 2,
                slidesPerGroup: 2,      
            },
            991: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },

        },
    });

    const reviewSlider = new Swiper('.abo-review-swiper', {
        modules: [Pagination, A11y],
        slidesPerView: 1.15,
        slidesPerGroup: 1,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,
        loop: false,
        autoplay: false,
        spaceBetween: 24,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        breakpoints: {
            768: {
                slidesPerView: 2.15,
                slidesPerGroup: 2,  
                slidesOffsetBefore: 16,
                slidesOffsetAfter: 16,     
            },
            991: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },

        },
        a11y: {
            paginationBulletMessage: 'Ga naar slide {{index}}',
        },
    });
});
